import { LineItem, PreFlight } from 'pupdocs/types';
import { apiGetRequest } from '../apiHttp';

export const apiPreFlights = {
  getPreFlights: () => apiGetRequest<{ lineItems: PreFlight[] }>(`pupdocs/line-item`),

  getById: (lineItemId: string) => {
    return apiGetRequest<{ lineItem: LineItem }>(`pupdocs/line-item/${lineItemId}`);
  },
};
